import { PRPLAYGROUND_OR_LOCAL } from './localOrPlayground'

const STACK_TRACE_MAX = 1000

export const captureError = (error: Error) => {
  // @ts-ignore
  const hasNewRelic = typeof window !== 'undefined' && window.newrelic !== undefined

  if (hasNewRelic && !PRPLAYGROUND_OR_LOCAL && error) {
    // this could be updated at some point, not sure why NewRelic doesnt like too long of a stacktrace
    const newError = new Error(error.message)
    newError.name = error.name
    newError.stack = error.stack?.substr(0, STACK_TRACE_MAX)
    // @ts-ignore
    window.newrelic.noticeError(newError)
  }
  if (error) {
    console.error(error)
  }
}



// WEBPACK FOOTER //
// ./src/utils/errors.ts